import { SubpageLayout2018 } from './subpageLayout';

const members = [
  {
    name: 'MR. FRANCIS FONG',
    title: 'Founding Chairman, Hong Kong Association of Interactive Marketing (HKAIM)',
    image: '/2018/images/judges_panel-1.jpg',
    id: 'member_1',
  },
  { name: 'MR. GARY YEUNG MAN YUI, MH', title: 'Vice President, Smart City Consortium', image: '/2018/images/judges_panel-2.jpg', id: 'member_2' },
  { name: 'DR. JEFFREY HUI', title: 'Chairperson, Hong Kong Institute of Marketing', image: '/2018/images/judges_panel-3.jpg', id: 'member_3' },
  {
    name: 'DR. KENNETH TANG',
    title: 'Adjunct Associate Professor of the Department of Urban Planning and Design, University of Hong Kong',
    image: '/2018/images/judges_panel-4.jpg',
    id: 'member_4',
  },
  {
    name: 'MR. RICKY CHU',
    title: 'Chairman, Hong Kong Retail Technology Industry Association\nFounder and CEO, The Gravitas Group',
    image: '/2018/images/judges_panel-5.jpg',
    id: 'member_5',
  },
  { name: 'DR. C P WONG, JP', title: 'President, Hong Kong eHealth Consortium', image: '/2018/images/judges_panel-6.jpg', id: 'member_6' },
  {
    name: 'DR. K F TSANG',
    title: 'Associate Professor, Department of Electronic Engineering, City University of Hong Kong',
    image: '/2018/images/judges_panel-7.jpg',
    id: 'member_7',
  },
];

export default function Judges2018() {
  return (
    <SubpageLayout2018 lang="en" title="Judges" page="judges">
      <div className="para_introduction">
        <h1>Judges</h1>
        <div className="center_introduction">
          <p className="p1"></p>
        </div>
        <div className="head_advisory_container">
          <div className="head_advisory_photo_container_responsive">
            <div className="head_advisory_photo">
              <img src="/2018/images/judge_head.jpg" alt="" />
            </div>
          </div>
          <div className="head_advisory_text_container animate" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>Head of Judge</div>
            <div className="head_advisory_name" style={{ fontFamily: 'Poppins', fontSize: 28 }}>HONORABLE CHARLES PETER MOK, JP</div>
            <div className="head_advisory_title" style={{ fontFamily: 'Poppins', marginBottom: 10 }}></div>
            <div className="head_advisory_text">
              Charles Peter Mok, is the Legislative Councillor representing the Information Technology Functional Constituency, member of The Professionals Guild. He has been serving the ICT industry for more than 20 years. He is currently the Vice Chairman of the Professional Commons, Honorary President of the Hong Kong Information Technology Federation and Founding Chairman of the Internet Society Hong Kong. Charles is active in public services with a view to upholding the core values of Hong Kong of which include democracy, liberty, human rights, rule of law and integrity, and is serving on various advisory bodies in the Hong Kong government, Hospital Authority, WKCDA, and higher educational institutions etc. Charles graduated from Purdue University in the United States with his Bachelor and Master degrees of Science in Computer and Electrical Engineering.
            </div>
          </div>
          <div className="head_advisory_photo_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="head_advisory_photo">
              <img src="/2018/images/judge_head.jpg" alt="" />
            </div>
          </div>
        </div>
        <div className="board_members_container_bg">
          <div className="board_members_container animate" data-animate="fadeIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
            <div className="board_members_subject" style={{ fontSize: 36, fontWeight: 'bold', marginBottom: 10 }}>Other Judges</div>
            <div className="member_all">
              {members.map((m) => (
                <div className={`member ${m.id}`} id={m.id} key={m.id}>
                  <div className="member_photo">
                    <img src={m.image} alt="" />
                  </div>
                  <div className="member_text_container">
                    <div className="member_text_name" style={{ fontSize: 20, fontWeight: 'bold' }}>{m.name}</div>
                    <div className="member_text_title" style={{ fontSize: 16, fontWeight: 100, whiteSpace: 'pre-line' }}>{m.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

